<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <hr class="mt-0" />

    <!-- ADMIN/OFFICER DASHBOARD -->
    <template v-if="isAdminOrOfficer">
      <div class="row">
        <div class="col-xl-12">
          <Stat />
        </div>
        <div class="col-xl-12">
          <SalesAnalytics />
          <EarningReport />
        </div>
      </div>
      <div class="row">
        <Transaction class="col"></Transaction>
      </div>
    </template>

    <!-- CLIENT DASHBOARD -->
    <template v-else-if="isClient">
      <div class="row">
        <ClientDetailsPage />
      </div>
    </template>

  </Layout>
</template>

<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";

import Stat from "./Grid1TodayUpdates";
import SalesAnalytics from "./Grid3OLBDoughnut";
import EarningReport from "./Grid4DisbursementHistory";
import Transaction from './Grid5LoanAgingTable';

import { userService } from "@/api/user.service";
import ClientDetailsPage from "../../ClientDetailsPage.vue";

export default {
  components: {
    Layout,
    PageHeader,
    Stat,
    SalesAnalytics,
    EarningReport,
    Transaction,
    ClientDetailsPage
  },
  data() {
    return {
      title: "Dashboard",
      items: [
        { text: "Finsis" },
        { text: "", active: true }
      ],
      roles: [],
      loadingRoles: true,
    };
  },
  computed: {
    isAdminOrOfficer() {
      return this.roles.includes("ADMIN") || this.roles.includes("OFFICER");
    },
    isClient() {
      return this.roles.includes("CLIENT");
    }
  },
  async mounted() {
    try {
      this.roles = await userService.fetchRoles();
    } catch (error) {
      console.error("Failed to fetch roles:", error.message);
    } finally {
      this.loadingRoles = false;
    }
  }
};
</script>